import {Component, inject, input, ChangeDetectionStrategy} from '@angular/core';
import {CustomFormControl} from '../CustomFormControl';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {FormHelperService} from '../../../services/form-helper.service';

@Component({
    selector: 'app-form-select',
    imports: [
        ReactiveFormsModule
    ],
    templateUrl: './form-select.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-select.component.scss'
})
export class FormSelectComponent {
  public formHelper = inject(FormHelperService);

  control = input.required<CustomFormControl>();
  formGroup = input.required<FormGroup>();
}
